import React from "react";
import useOnlineVendorOrdering from "./OnlineVendorOrdering.hook";
import ManageVendor from "./ManageVendor";
import DeleteVendorConfirm from "./DeleteVendorConfirm";
import AddNewFields from "./AddNewFields";
import VendorItem from "./VendorItem";
import VendorCardShimmer from "./VendorCardShimmer";

const OnlineVendorOrdering = () => {
  const {
    loading,
    vendorsList,
    handleToggleDialog,
    showDialog,
    handleCloseDialog,
    isEdit,
    handleEdit,
    handleChange,
    selectedItem,
    modified,
    handleSubmit,
    handleDelete,
    handleImage,
    handleConfirmDelete,
    handleAddFields,
    store,
    btnLoading,
    isAdmin
  } = useOnlineVendorOrdering();

  const renderVendorList = () => {
    if(loading){
      return ( <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
      <VendorCardShimmer />
      <VendorCardShimmer />
      <VendorCardShimmer />
      <VendorCardShimmer />
      <VendorCardShimmer />
      <VendorCardShimmer />
      <VendorCardShimmer />
      <VendorCardShimmer />
      <VendorCardShimmer />
    </div>)
    }
    if (!store) {
      return (
        <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4  mt-3">
          Please select store
        </div>
      );
    }
    if (vendorsList?.length === 0) {
      return (
        <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4  mt-3">
          No Vendors Available
        </div>
      );
    }
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mt-3">
        {vendorsList?.map((i, index) => {
          return (
            <VendorItem
              key={index}
              vendorItem={i}
              handleEdit={handleEdit}
              isAdmin={isAdmin}
              handleDelete={handleDelete}
              handleAddFields={handleAddFields}
            />
          );
        })}
      </div>
    );
  };
  return (
    <>
      <div className="py-6 mt-16">
        <header>
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
              Vendors List
            </h1>
            <div className="flex justify-end">
              {isAdmin ? <button
                style={{ height: "38px", marginLeft: "10px" }}
                type="button"
                onClick={() => handleToggleDialog("manageVendor", true)}
                className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
              >
                Add Vendor Gateway
              </button>:null}
            </div>
          </div>
        </header>
        <main>
          {/* {loading ? <DashboardLoader /> : null} */}
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
            {renderVendorList()}
          </div>
        </main>
      </div>
      {showDialog?.manageVendor ? (
        <ManageVendor
          handleCloseDialog={handleCloseDialog}
          isEdit={isEdit}
          handleChange={handleChange}
          handleImage={handleImage}
          selectedItem={selectedItem}
          modified={modified}
          handleSubmit={handleSubmit}
          btnLoading={btnLoading}
        />
      ) : null}
      {showDialog?.delete ? (
        <DeleteVendorConfirm
          handleCloseDialog={handleCloseDialog}
          selectedItem={selectedItem}
          handleConfirmDelete={handleConfirmDelete}
        />
      ) : null}
      {showDialog?.addfields ? (
        <AddNewFields
          handleCloseDialog={handleCloseDialog}
          selectedItem={selectedItem}
          handleConfirmDelete={handleConfirmDelete}
        />
      ) : null}
    </>
  );
};

export default OnlineVendorOrdering;
